import React from 'react';
import './TypingIndicator.css';

const TypingIndicator = () => {
    return (
        <div className="typing-indicator">
            <div className="typing-dots">
                <div className="typing-dot"></div>
                <div className="typing-dot"></div>
                <div className="typing-dot"></div>
            </div>
        </div>
    );
};

export default TypingIndicator;